import { render, staticRenderFns } from "./RegisterCustomerDns.vue?vue&type=template&id=76b1f580&"
import script from "./RegisterCustomerDns.vue?vue&type=script&lang=js&"
export * from "./RegisterCustomerDns.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCustomerDns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports